import { ResetPassword } from "@/features/account/components/forgot-password/reset-password";
function ForgotPassword() {
    return <ResetPassword />;
}

export default ForgotPassword;
